export default "__VITE_ASSET__BHDASh7H__"